export const formatAutoJerryUpdatedDate = (date: Date): string => {
  return date.toLocaleDateString('fi-FI', {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
  });
};
